// extracted by mini-css-extract-plugin
export default {"award":"Award_award__CHmgP","award-image":"Award_award-image__Td-80","award-text":"Award_award-text__XF2lh"};